var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-head"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"d-flex"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"ml-2 mt-1"},[_vm._t("left")],2)]),_c('div',{staticClass:"pull-right"},[_vm._t("right")],2)]),_vm._l((_vm.tabs),function(tab,index){return _c('b-link',{key:`${tab.routeName}_${index}`,staticClass:"mr-4 d-inline-block",class:_vm.activeFunc(tab) ? 'active-page-tab' : '',attrs:{"to":{
        name: tab.routeName,
        params: tab.routeParams,
        query: tab.queryParams,
      }},on:{"click":_vm.persistHash}},[_vm._v(" "+_vm._s(tab.title)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }